import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "settings-payment mt-1 mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SettingsItem = _resolveComponent("SettingsItem");

  var _component_draggable = _resolveComponent("draggable");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings.payment-methods.title")), 1), _createVNode(_component_draggable, {
    modelValue: _ctx.settingsData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.settingsData = $event;
    }),
    handle: ".handle",
    "item-key": "id"
  }, {
    item: _withCtx(function (_ref) {
      var element = _ref.element;
      return [_createVNode(_component_SettingsItem, {
        settingInfo: element,
        ref: function ref(el) {
          if (el) _ctx.paymentForms[_ctx.i] = el;
        }
      }, null, 8, ["settingInfo"])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}